import { OnComplete } from "../Sagas/redux-saga-callback/withCallback";

export const enum PersonalizationActionTypes {
    LOAD = "PERSONALIZATION/LOAD",
    SAVE = "PERSONALIZATION/SAVE",
}

type LoadArgs = {
    key: string;
    onComplete?: OnComplete;
};

export const loadPersonalization = ({ key, onComplete }: LoadArgs) =>
    ({
        type: PersonalizationActionTypes.LOAD,
        key,
        onComplete,
    } as const);

export type SavePersonalizationArgs<T = any> = {
    key: string;
    data: T;
};

export const savePersonalization = <T = any>({ key, data }: SavePersonalizationArgs<T>) =>
    ({
        type: PersonalizationActionTypes.SAVE,
        key,
        data,
    } as const);
